<!--
首页故障趋势
-->
<template>
  <el-row :gutter="20" style="width: 100%">
    <!-- 趋势 -->
    <el-col :lg="16" v-loading="loadingData">
      <div class="box" style="margin-top: 20px">
        <div class="title" style="margin-bottom: 25px">工单统计</div>
        <el-row :gutter="10">
          <el-col :md="14">
            <el-row :gutter="10">
              <el-col :span="8">
                <div class="fault-item">
                  <div class="flex-col-center" style="height: auto">
                    <div class="item-icon"></div>
                    <div class="item-title">工单总数</div>
                  </div>
                  <div>{{ faultData.all || 0 }}</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="fault-item">
                  <div class="flex-col-center" style="height: auto">
                    <div class="item-icon" style="border-color: #2a61ff"></div>
                    <div class="item-title">处理中</div>
                  </div>
                  <div>{{ faultData.onCount || 0 }}</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="fault-item">
                  <div class="flex-col-center" style="height: auto">
                    <div class="item-icon" style="border-color: #42ceaf"></div>
                    <div class="item-title">已完成</div>
                  </div>
                  <div>{{ faultData.complete || 0 }}</div>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :md="10">
            <el-row :gutter="10">
              <el-col :span="12">
                <div class="fault-item">
                  <div class="flex-col-center" style="height: auto">
                    <div class="item-icon" style="border-color: #ff9b6f"></div>
                    <div class="item-title">平均处理时间</div>
                  </div>
                  <div>
                    {{ faultData.average || 0 }}
                    <span style="font-family: DIN">mine</span>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="fault-item">
                  <div class="flex-col-center" style="height: auto">
                    <div class="item-icon" style="border-color: #6f76ff"></div>
                    <div class="item-title">完成效率</div>
                  </div>
                  <div>{{ faultData.completeRatio || 0 }}</div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <div id="echart-line" style="height: 275px"></div>
      </div>
    </el-col>

    <!-- 公告/消息 -->
    <el-col :lg="8">
      <div class="box" style="margin-top: 20px">
        <div class="flex-row-sb">
          <div class="flex">
            <div
              :class="['menu-item', { title: index == menuActive }]"
              v-for="(item, index) in menu"
              :key="index"
              @click="switchMenu(index)"
            >
              {{ item }}
              <div class="item-icon" v-show="menuActive == index"></div>
              <div class="item-num" v-if="index == 0 && unReadCount > 0">
                {{ unReadCount }}
              </div>
              <div class="item-num" v-if="index == 1 && msgUnReadCount > 0">
                {{ msgUnReadCount }}
              </div>
            </div>
          </div>
        </div>

        <!-- 公告通知 -->
        <div style="height: 385px" v-show="menuActive == 0">
          <div v-loading="noticeLoading">
            <div
              class="message-item flex-row-sb"
              v-for="(item, index) in noticeList"
              :key="index"
              @click="jump('/announcementDetail', item, index)"
            >
              <div class="item-content flex-col-center">
                <img :src="item.avatar" class="content-header" />
                <div class="content-val">
                  <div class="val-text" style="font-size: 16px;">{{ item.title }}</div>
                  <div class="val-text" style="color: #888888;">
                    {{ item.description }}
                  </div>
                </div>
              </div>
              <div class="item-date">
                <div>{{ item.time }}</div>
                <div class="yidu-icon" v-if="item.isRead == 1">
                  <img src="@/assets/images/home_icon_yidu.png" />
                </div>
              </div>
            </div>
            <div
              class="no-data"
              v-if="!noticeLoading && noticeList.length == 0"
            >
              暂无公告
            </div>
          </div>
          <el-pagination
            background
            layout="prev, pager, next"
            hide-on-single-page
            :page-size="8"
            :current-page.sync="noticePage"
            :total="noticeTotal"
            @current-change="getNoticeList"
            class="box-paging"
          >
          </el-pagination>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import * as echarts from 'echarts'

export default {
  components: {},
  data() {
    return {
      faultData: {}, // 故障趋势数据
      loadingData: false, // 故障趋势loading

      lineChart: null,
      lineOption: null,

      menu: ['公告通知'],
      menuActive: 0,

      noticeList: [], // 公告列表
      noticePage: 1, // 公告当前页码
      noticeTotal: 1, // 公告总条数
      noticeLoading: false, // 公告loading
      unReadCount: 0 // 公告消息未读数
    }
  },
  watch: {},
  mounted() {
    this.getData()
    this.getNoticeList()
    this.getNoticeUnReadCount()

    window.addEventListener('resize', () => {
      this.lineChart.resize()
    })
  },
  methods: {
    // 获取故障趋势数据
    getData() {
      this.loadingData = true
      this.$api.home
        .faultTrend()
        .then(({ data }) => {
          this.loadingData = false
          if (data.code == 200) {
            this.faultData = data.data
            this.initLine(this.faultData.faultStatistics)
          }
        })
        .catch(() => {
          this.loadingData = false
        })
    },

    initLine(data) {
      this.lineChart = echarts.init(document.getElementById('echart-line'))
      this.lineOption = {
        title: {
          text: '故障统计',
          textStyle: {
            color: '#40424F',
            fontSize: '14px',
            fontFamily: 'PingFang SC'
          }
        },
        legend: {},
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#000',
            fontSize: '12'
          },
          axisLine: {
            lineStyle: {
              color: '#E4E8F9'
            }
          },
          data: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月'
          ]
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true, // 显示y轴线
            lineStyle: {
              color: '#E4E8F9'
            }
          }
        },
        series: [],
        tooltip: {
          axisPointer: {
            type: 'cross'
          }
        },
        grid: {
          top: 50,
          left: 50,
          bottom: 20,
          right: 10
        }
      }

      data.forEach((item, index) => {
        const option = this.lineOption
        const obj = {
          type: 'line',
          name: item.deptName,
          smooth: true, // 曲线平滑
          areaStyle: {},
          data: item.faultStatisticsList.map((item) => item.faultCount)
        }
        option.series.push(obj)
      })

      this.lineChart.setOption(this.lineOption)
    },

    // 切换菜单
    switchMenu(index) {
      this.menuActive = index
    },

    // 获取公告列表
    getNoticeList() {
      this.noticeLoading = true
      this.$api.home
        .noticeList({
          limit: 4,
          page: this.noticePage
        })
        .then(({ data }) => {
          this.noticeLoading = false
          if (data.code == 200) {
            this.noticeList = data.data
            this.noticeTotal = data.total
          }
        })
        .catch(() => {
          this.noticeLoading = false
        })
    },

    // 获取公告消息未读数
    getNoticeUnReadCount() {
      this.$api.home.noticeUnReadCount().then(({ data }) => {
        if (data.code == 200) {
          this.unReadCount = data.data
        }
      })
    },

    // 跳转
    jump(path, data, index) {
      this.$router.push({ path, query: { id: data.noticeId } })
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  padding: 30px 25px;
  background: #ffffff;
  border-radius: 14px;
}

.title {
  font-size: 16px;
  font-weight: bold;
  color: #333333 !important;
}

.fault-item {
  height: 109px;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 10px;
  background: #f5f7fe;
  border-radius: 6px;
  font-size: 28px;
  font-family: 'Bebas Neue';
  color: #484a56;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .item-icon {
    width: 14px;
    height: 14px;
    margin-right: 8px;
    background: #fafafa;
    border: 4px solid #ec7676;
    box-sizing: border-box;
    border-radius: 50%;
  }
  .item-title {
    font-size: 14px;
    color: #a2aebf;
  }
}

.menu-item {
  margin-right: 50px;
  color: rgba(51, 51, 51, 0.4);
  margin-bottom: 33px;
  position: relative;
  cursor: pointer;
  position: relative;
  :last-child {
    margin-right: 0;
  }
  .item-icon {
    position: absolute;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%);
    width: 23px;
    height: 3px;
    background: #4799ff;
  }
  .item-num {
    position: absolute;
    top: -10px;
    right: -17px;
    width: 18px;
    height: 18px;
    background: #fe0101;
    border-radius: 50%;
    text-align: center;
    line-height: 18px;
    font-size: 13px;
    font-family: 'DIN';
    font-weight: bold;
    color: #ffffff;
  }
}

.more-text {
  font-size: 14px;
  color: #999999;
  cursor: pointer;
}

.message-item {
  padding: 17px 10px;
  box-sizing: border-box;
  border-radius: 4px;
  border-bottom: 1px solid #e9effd;
  transition: all 0.2s;
  cursor: pointer;
  &:hover {
    background: #f2f6ff;
    border-color: #e9effd;
  }
  &:last-child {
    border: none;
  }
  .item-content {
    flex: 1;
    height: 50px;
    margin-right: 20px;
    min-width: 0;
    .content-header {
      width: 50px;
      height: 100%;
      margin-right: 15px;
      border-radius: 50%;
      object-fit: cover;
    }
    .content-val {
      flex: 1;
      min-width: 0;
      height: 100%;
      padding: 5px 0;
      box-sizing: border-box;
      font-size: 14px;
      color: #40424f;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .val-text {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .mes-title {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  .item-date {
    font-size: 14px;
    color: #40424f;
    opacity: 0.5;
    .yidu-icon {
      width: 100%;
      height: 100%;
      margin-top: 13px;
      display: flex;
      justify-content: flex-end;
      img {
        width: 100%;
        height: 100%;
        width: 20px;
        height: 20px;
      }
    }
  }
}

.no-data {
  color: #999;
  text-align: center;
}

.dialog-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 20px;
  color: #000;
}
.dialog-time {
  margin-top: 10px;
  color: #999;
}
</style>
